import script from "./DispatchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DispatchModal.vue?vue&type=script&setup=true&lang=js"

import "./DispatchModal.vue?vue&type=style&index=0&id=76ff8503&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ff8503"]])

export default __exports__